module.exports = __webpack_public_path__ + "img/SEO-SEA.b9204bc3.jpg";